import React from 'react';
import './GlobalLoader.css';

/**
 * GlobalLoader Component
 * Full-screen loader with travel-themed animation
 * Shows an animated airplane flying around a globe with loading text
 * Only displays when isLoading is true
 */
const GlobalLoader = ({ isLoading }) => {
    // Don't render if not loading
    if (!isLoading) return null;

    return (
        <div className="global-loader-overlay">
            <div className="global-loader-content">
                {/* Animated Globe */}
                <div className="loader-globe">
                    <div className="globe-sphere">
                        <div className="globe-line globe-line-1"></div>
                        <div className="globe-line globe-line-2"></div>
                        <div className="globe-line globe-line-3"></div>
                        <div className="globe-equator"></div>
                    </div>
                    {/* Animated Airplane */}
                    <div className="loader-airplane">
                        <i className="fa-solid fa-plane"></i>
                    </div>
                    {/* Flight path trail */}
                    <div className="flight-trail"></div>
                </div>

                {/* Loading Text */}
                <div className="loader-text">
                    <span>Preparing your journey</span>
                    <div className="loader-dots">
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GlobalLoader;
